import BackToMain from "./BackTo/BackTo.jsx";

export default {
    BackToMain
};